var _style, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgOtherTransportErrorA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0;}.cls-2{fill:#f9e6c9;}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    id: "MRK-general_x5F_warning_x5F_24_1_",
    d: "M21.5,21h-19c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2-0.1-0.3,0-0.5l9.5-17 c0.2-0.3,0.7-0.3,0.9,0l9.5,17c0.1,0.2,0.1,0.3,0,0.5C21.8,20.9,21.7,21,21.5,21z M3.4,20h17.3L12,4.5L3.4,20z M12,16.7 c-0.7,0-1.2,0.6-1.2,1.2c0,0.7,0.6,1.3,1.2,1.3s1.2-0.6,1.2-1.3C13.2,17.3,12.7,16.7,12,16.7z M13,14.5v-5c0-0.6-0.4-1-1-1 s-1,0.4-1,1v5c0,0.6,0.4,1,1,1S13,15.1,13,14.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 144,
    height: 144
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgOtherTransportErrorA);
export default __webpack_public_path__ + "static/media/img_OtherTransportError_a.02a8b9817fe00edcf67e4969a73c4046.svg";
export { ForwardRef as ReactComponent };